import { Box } from "@mui/material";
import React from "react";
import { FixedBottomArea } from "../Atoms/FixedBottomArea";

interface PageWithFixedBottomProps {
  children: React.ReactNode;
  bottomContent: React.ReactNode;
  bottomPadding?: string | number;
}

export const PageWithFixedBottom: React.FC<PageWithFixedBottomProps> = ({
  children,
  bottomContent,
  bottomPadding = "100px",
}) => {
  return (
    <>
      <Box sx={{ pb: bottomPadding }}>{children}</Box>
      <FixedBottomArea>{bottomContent}</FixedBottomArea>
    </>
  );
};
